import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';
import styles from './ship-together-destination-modal.module.less';
import ModalPortal from '../../modal-portal';
import { ErrorModal } from '../error-modal';
import { messages } from './messages';

export const PackingSlipSharingErrorModal = ({ onClose }) => {
  const intl = useIntl();
  return (
    <ModalPortal onClose={onClose}>
      <ErrorModal
        buttons={[
          {
            theme: 'primary',
            children: intl.formatMessage(messages.packingSlipsErrorCancelButton),
          },
        ]}
        className={styles['error-modal']}
        message={intl.formatMessage(messages.packingSlipsErrorBody)}
        modalFrameworkMethods={{ closeModal: onClose }}
        title={intl.formatMessage(messages.packingSlipsErrorTitle)}
      />
    </ModalPortal>
  );
};

PackingSlipSharingErrorModal.propTypes = {
  onClose: PropTypes.func.isRequired,
};
